export default "__VITE_ASSET__f00efd58__"